import React from 'react'
import { FiCheck, FiLoader } from 'react-icons/fi'

export default function Checkbox({ checked, onClick, className, loading }) {
  return (
    <div
      onClick={!loading && onClick}
      className={`form-input flex justify-center bg-white items-center flex-shrink-0 w-8 h-8 p-0 cursor-pointer ${className}`}>
      {loading && <FiLoader className="h-4 w-4 stroke-1 rotating box-border" />}
      {!loading && checked && <FiCheck className="stroke-2 w-4 h-4" />}
    </div>
  )
}
